(($) => {

    'use strict'
    const $form = $('#livestream-create');
    if ($form.length === 0) {
        return;
    }

    const $brandIdSelector = $('#brand_id');
    const ajaxUrl = $brandIdSelector.data('ajaxUrl');
    const csrfToken = $('meta[name="csrf-token"]').attr('content');
    const selectedBrandId = $brandIdSelector.find(':selected').val();
    const $brandFieldsContainer = $('#brand-is-selected');
    const livestreamId = $('#livestream_id').val();
    const _loadGroups = brandId => {
        if (brandId === '') {
            $brandFieldsContainer.empty()
            return;
        }

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                brandId: brandId,
                livestreamId: livestreamId,
                schoolYearId : $('#school_year_id').find(':selected').val(),
                _token: csrfToken
            },
            dataType: 'html',
            success: response => {
                $brandFieldsContainer.empty().append(response);
                $brandFieldsContainer.find('select').select2({theme: 'bootstrap4'});
            }
        }).done(function () {
            $('select[name="subject_id"]').change(function() {
                $.ajax({
                    url: '/admin/edu-space/livestream/subject-is-selected',
                    data: {
                        subjectId: this.value,
                        csrf: csrfToken,
                    },
                    dataType: 'html',
                    success: response => {
                        $('#teachers').empty().append(response);
                    }
                })
            })
        })
    };

    $(function () {
        $brandIdSelector.change(function () {
            const brandId = $(this).val();
            _loadGroups(brandId)
        });

        _loadGroups(selectedBrandId);
    });

})($);
